module.exports = "/_next/static/images/8184322309612cd39204969840cd2f2a-wow@0.5x.jpg";